import { useTranslation } from "react-i18next";
import FadeInUp from "./FadeInUp";

const SHOTS = [
  {
    img: "/assets/landing/recruitment.png",
    badge: { fr: "ATS", en: "ATS", ar: "ATS" },
    title: { fr: "Recrutement & Cycle de Vie", en: "Recruitment & Lifecycle", ar: "التوظيف ودورة الحياة" },
    body: {
      fr: "Offres, pipeline kanban, entretiens, e-signature et onboarding — du candidat à l'employé, sans rupture.",
      en: "Job postings, kanban pipeline, interviews, e-signature and onboarding — from candidate to employee, seamlessly.",
      ar: "إعلانات الوظائف وخط الأنابيب والمقابلات والتوقيع الإلكتروني والإلحاق — من المرشح إلى الموظف بسلاسة.",
    },
  },
  {
    img: "/assets/landing/performance.png",
    badge: { fr: "Talent", en: "Talent", ar: "المواهب" },
    title: { fr: "Performance & Développement", en: "Performance & Development", ar: "الأداء والتطوير" },
    body: {
      fr: "Cycles d'évaluation, OKR, feedback 360° et recommandations salariales pour faire grandir vos équipes.",
      en: "Review cycles, OKRs, 360° feedback and pay recommendations to grow your teams.",
      ar: "دورات التقييم والأهداف والتغذية الراجعة 360° وتوصيات الأجور لتنمية فرقك.",
    },
  },
  {
    img: "/assets/landing/executive.png",
    badge: { fr: "Analytics", en: "Analytics", ar: "تحليلات" },
    title: { fr: "Tableau de Bord Exécutif", en: "Executive Dashboard", ar: "لوحة القيادة التنفيذية" },
    body: {
      fr: "KPIs RH temps réel : effectifs, turnover, masse salariale et performance, en une vue direction.",
      en: "Real-time HR KPIs: headcount, turnover, payroll and performance, in one leadership view.",
      ar: "مؤشرات أداء الموارد البشرية الفورية: الأعداد والدوران والرواتب والأداء في عرض واحد للإدارة.",
    },
  },
];

const LandingShowcase = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (obj) => obj[lang] || obj.fr;

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: "#0a0b0c", borderTop: "1px solid #18191a" }}>
      <div className="max-w-7xl mx-auto">
        <FadeInUp>
          <div style={{ textAlign: "center", maxWidth: "560px", margin: "0 auto 64px" }}>
            <span
              style={{
                display: "inline-block",
                fontSize: "12px",
                fontWeight: 500,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                padding: "4px 14px",
                borderRadius: "9999px",
                color: "#5e6ad2",
                backgroundColor: "rgba(94,106,210,0.10)",
                border: "1px solid rgba(94,106,210,0.20)",
                marginBottom: "20px",
              }}
            >
              {t({ fr: "Aperçu produit", en: "Product tour", ar: "جولة في المنتج" })}
            </span>
            <h2
              style={{
                color: "#f7f8f8",
                fontSize: "clamp(28px, 4vw, 40px)",
                fontWeight: 600,
                lineHeight: 1.15,
                letterSpacing: "-1.0px",
                marginBottom: "16px",
              }}
            >
              {t({ fr: "Conçu pour toute votre équipe", en: "Built for your whole team", ar: "مصمم لفريقك بالكامل" })}
            </h2>
            <p style={{ color: "#8a8f98", fontSize: "16px", lineHeight: 1.5, letterSpacing: "-0.05px" }}>
              {t({
                fr: "Des captures réelles de Mawered en production — pas des maquettes.",
                en: "Real screenshots from Mawered in production — not mockups.",
                ar: "لقطات حقيقية من Mawered في الإنتاج — وليست نماذج.",
              })}
            </p>
          </div>
        </FadeInUp>

        <div className="grid lg:grid-cols-3 gap-6">
          {SHOTS.map((shot, i) => (
            <FadeInUp key={i} delay={i * 0.08}>
              <div
                style={{
                  backgroundColor: "#0f1011",
                  border: "1px solid #23252a",
                  borderRadius: "14px",
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "rgba(94,106,210,0.4)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 32px rgba(94,106,210,0.1), 0 0 0 1px rgba(94,106,210,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#23252a";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{ borderBottom: "1px solid #18191a", backgroundColor: "#080809" }}>
                  <img
                    src={shot.img}
                    alt={t(shot.title)}
                    loading="lazy"
                    style={{ display: "block", width: "100%", height: "auto" }}
                  />
                </div>
                <div style={{ padding: "20px 22px 24px" }}>
                  <span
                    style={{
                      fontSize: "9px",
                      fontWeight: 600,
                      letterSpacing: "0.4px",
                      textTransform: "uppercase",
                      padding: "2px 7px",
                      borderRadius: "9999px",
                      color: "#5e6ad2",
                      backgroundColor: "rgba(94,106,210,0.12)",
                      border: "1px solid rgba(94,106,210,0.2)",
                      display: "inline-block",
                      marginBottom: "12px",
                    }}
                  >
                    {t(shot.badge)}
                  </span>
                  <div
                    style={{
                      color: "#f7f8f8",
                      fontSize: "16px",
                      fontWeight: 500,
                      letterSpacing: "-0.3px",
                      marginBottom: "8px",
                    }}
                  >
                    {t(shot.title)}
                  </div>
                  <p style={{ color: "#8a8f98", fontSize: "14px", lineHeight: 1.5 }}>{t(shot.body)}</p>
                </div>
              </div>
            </FadeInUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingShowcase;
